// Suggestion sets for the freeform profile "prompt" pickers. Every picker also
// lets you add your own — these are just starters. The mix is intentional:
// some have cultural swagger (a24 films, orange wine, 90s R&B, ballroom), some
// are deliberately broad (cooking, hiking, dogs) so the lists land for everyone,
// not just the very-online.

// "Things you're into" — culture / interest tags shown on the public profile.
export const INTO_SUGGESTIONS = [
  // broadly loved (with a little taste)
  "Live music", "Foodie", "Cooking", "Cocktails",
  "Specialty coffee", "Matcha", "Natural wine",
  // music & nightlife
  "Techno", "90s R&B", "Jazz", "Vinyl", "Karaoke",
  // film / books / art
  "A24 films", "Letterboxd", "Film photography", "Bookstores", "Theater",
  "Stand-up comedy", "Museums",
  // queer culture
  "Drag", "Queer history",
  // moving your body
  "Hiking", "Run club", "Pilates", "Hot yoga", "Climbing", "Tennis",
  "Pickleball", "Swimming", "Beach days",
  // making & collecting
  "Thrifting", "Tattoos", "Ceramics", "Plants",
  // nights in
  "Video games", "Astrology", "Reality TV", "Podcasts", "Skincare",
  // the universals
  "Dogs", "Cats", "Traveling", "Road trips",
];

// "Currently watching, reading, listening to" — Bumble-style SPECIFIC titles
// (actual shows, artists, books) rather than vague genres, so people get granular
// about what they're actually into. They add their own from here.
export const CONSUMING_SUGGESTIONS = [
  // watching
  "Stranger Things", "The White Lotus", "Drag Race", "Love Island", "Severance",
  "The Last of Us", "Heartstopper", "The Traitors", "Bridgerton", "The Bear",
  "Real Housewives", "Challengers", "Bottoms", "Hacks",
  // listening
  "Taylor Swift", "Chappell Roan", "Sabrina Carpenter", "Charli XCX", "Beyoncé",
  "SZA", "Troye Sivan", "Olivia Rodrigo", "Frank Ocean", "Lady Gaga", "Kendrick Lamar",
  // reading
  "Sally Rooney", "A Little Life", "Fourth Wing", "James Baldwin", "Ocean Vuong",
];

// "Looking to" — what you're hoping to get out of dinners / the app. Outclose is
// a friendship app first, so these stay firmly in friends/community territory —
// no dating/romance intents ("Date", "Something serious", etc. are intentionally
// absent).
export const LOOKING_TO_SUGGESTIONS = [
  "Make new friends", "Find my people", "Find my crew", "Build community",
  "Meet other queers", "Find my chosen family", "Deepen my friendships",
  "Expand my circle", "Try new restaurants", "Find a gym buddy",
  "Find a travel buddy", "New in town", "Get out more",
];
